import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routing from "./routing";
import CustomTheme from "./theme";
import store from "./redux/store";
import { bootstrapRequest } from "./redux/modules/auth/authSlice";

// Calls /auth/me on mount so the SPA knows whether the HttpOnly cookie is
// still valid before any route makes a redirect decision. Shows a spinner
// for the (typically <100ms) round-trip rather than flashing the login page.
function AuthBootstrap({ children }) {
  const dispatch = useDispatch();
  const bootstrapped = useSelector((s) => s.auth.bootstrapped);

  useEffect(() => { dispatch(bootstrapRequest()); }, [dispatch]);

  if (!bootstrapped) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }
  return children;
}

function App() {
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <CustomTheme>
            <AuthBootstrap>
              <Routing />
            </AuthBootstrap>
          </CustomTheme>
        </BrowserRouter>
      </Provider>
      <ToastContainer />
    </>
  );
}

export default App;